module.exports = __webpack_public_path__ + "static/media/payment4.523789a1.png";